import {handleResponse} from "@/services/service-helpers"

const SYSTEM_EMAIL_STATUS_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/auth/system-email-status`

export async function getSystemEmailStatus(): Promise<{ configured: boolean }> {
    try {
        const response = await fetch(SYSTEM_EMAIL_STATUS_URL, {method: "GET"})
        return await handleResponse<{ configured: boolean }>(response) as { configured: boolean }
    } catch {
        return {configured: false}
    }
}
